import { render, staticRenderFns } from "./folderTreeTest.vue?vue&type=template&id=5299af2a&scoped=true"
import script from "./folderTreeTest.vue?vue&type=script&lang=js"
export * from "./folderTreeTest.vue?vue&type=script&lang=js"
import style0 from "./folderTreeTest.vue?vue&type=style&index=0&id=5299af2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5299af2a",
  null
  
)

export default component.exports